import Token from '@/utils/Token';

export default {
    list() {
        return axios.get('/api/cancelamento/sla-config', Token.getHeader());
    },
    update(id, payload) {
        return axios.put(`/api/cancelamento/sla-config/${id}`, payload, Token.getHeader());
    },
    extractErrorMessage(error) {
        const err = error?.response?.data;
        if (err?.msg) return err.msg;
        if (err?.message) return err.message;
        if (error?.message) return error.message;
        return 'Ocorreu um erro inesperado.';
    },
};
